// extracted by mini-css-extract-plugin
export default {"title":"NavList_title__DR0tC","nav_item":"NavList_nav_item__t8oty"};